import React, { useState, useEffect } from "react";
// import Baseurl, { baseurlotp, DealerUrl, Userurl } from "../Baseurl";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import {getDealerUrl } from "../Components/Configlaoder"
const Dealerform = () => {

    
      const [DealerUrl, setDealerurl] = useState("");
   
  useEffect(() => {
    const fetchDealerUrl = async () => {
      try {
        const url = await getDealerUrl();
        setDealerurl(url);
      } catch (error) {
        console.error("Error fetching base URL:", error);
      }
    };
 
    fetchDealerUrl();
  }, []);


  const nav = useNavigate();
  const currentDate = new Date();
  const eighteenYearsAgo = new Date(
    currentDate.getFullYear() - 18,
    currentDate.getMonth(),
    currentDate.getDate()
  );

  // Format the date as YYYY-MM-DD, which is the required format for the <input type="date"> element
  const formattedEighteenYearsAgo = `${eighteenYearsAgo.getFullYear()}-${(
    eighteenYearsAgo.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${eighteenYearsAgo
      .getDate()
      .toString()
      .padStart(2, "0")}`

  
  //  const [msisdnv , setMsisdn] = useState([]);
  const [message, setmessage] = useState("");
  const [circles, setCircles] = useState([]);
  const [ AadharAllow , setAadharAllow] = useState("");
    const [ PanAllow , setPanAllow] = useState("");
  const [dealerCreation, setDealerCreation] = useState("");
  const [circlein, setCirclein] = useState("");
    // const [loading, setloading] = useState(false);
  const [cancel, setCancel] = useState("");
  const [selectedCircle, setSelectedCircle] = useState("");
  const [showPopup1, setShowPopup1] = useState(false);
  const [ssas, setSsas] = useState([]);
  const [selectedSsa, setSelectedSsa] = useState("");
  const [category1, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [dealerType, setDealerType] = useState([]);
  const [selectedDealerType, setSelectedDealerType] = useState("");
  const [taxtype, setTaxtype] = useState([]);
  const [selectedTaxtype, setSelectedTaxtype] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showSsa, setShowSsa] = useState(true);
  const [showCircle, setShowCircle] = useState(true);
  const [showCircle1, setShowCircle1] = useState(false);
  const [showSsa1, setShowSsa1] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isApiSuccess, setIsApiSuccess] = useState(true);
  const [dealerValue, setDealervalue] = useState([]);
  // const [showMand , setShowMand] = useState (false)
  const [dealercreated, setDealercreated] = useState("");
  const [m1, setM1] = useState("");
  const [m2, setM2] = useState("");
  const [errors, setErrors] = useState({});
  const [circleId, setcircleId] = useState("");
  const [ssaId, setSsaId] = useState("");
  const [inputs, setInputs] = useState({
    firstName: "",
    createdBy: "",
    lastName: "",
    houseNumber: "",
    iccidNumber: "",
    ctopupMsisdn: "",
    mobile: "",
    dob: "",
    address: "",
    pincode: "",
    dealerType: "",
   
    emailId:"",
    aadhaarId:"",
    panId:"",
    
    category: "",
    franchiseMsisdn: '',
    subFranchiseMsisdn: ''

  });

  const [show, setShow] = useState(false);
    const [showPan, setShowPan] = useState(false);
      const [showAadhar, setShowAadhar] = useState(false);
    
     const [aadhar, setaadhar] = useState('');
      const [pan, setpan] = useState('');
  const [show1, setShow1] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [error, setError] = useState('');
  const [error1, setError1] = useState('');
 
 
 

 
    

// Log the msisdn value
  const [shouldAddInput, setShouldAddInput] = useState(false);
  const [shouldAddInputs, setShouldAddInputs] = useState(false);



  const handleCircleChange = (event) => {
    let selectedCircleId = event.target.value;
    
  
    
  setcircleId(selectedCircleId)
    
    
    const { name, value } = event.target;
    setErrors({
      ...errors,
      [name]: (value && typeof value === 'string' && value.trimStart()) ? "" : `${name} is required`,
    });
    
  };

  const handleSsaChange = (event) => {
    let selectedSsaId = event.target.value;
    setSsaId(selectedSsaId);
    
   
    const { name, value } = event.target;
    setErrors({
      ...errors,
      [name]: (value && typeof value === 'string' && value.trimStart()) ? "" : `${name} is required`,
    });
    

  };

  const handleCategoryChange = (event) => {
    let selectedCategoryId = event.target.value;
    setSelectedCategory(selectedCategoryId);
    setInputs((inputs) => ({
      ...inputs,
      category: selectedCategoryId


    }));
    const { name, value } = event.target;
    setErrors({
      ...errors,
      [name]: (value && typeof value === 'string' && value.trimStart()) ? "" : `${name} is required`,
    });
    

  };

  const handleDealerTypeChange = (event) => {
    let selectedDealerTypeId = event.target.value;
    setSelectedDealerType(selectedDealerTypeId);
    setInputs((inputs) => ({
      ...inputs,
      dealerType: selectedDealerType
    }));

  };

          const handleSubmit = async (e)  =>{
            e.preventDefault()
           
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
  ...inputs,
  circleId: 19,
  ssaId: 234
}),
        };
console.log(inputs);
        try {
          const res = await fetch(`${DealerUrl}/ctopup-dealer/create`, requestOptions);
          const response = await res.json();
          console.log(response);
          console.log(response.data);
          setDealercreated(response);
          if (res.status == 201) {
            setShowPopup1(true);
            setShowPopup(false);
            // window.location.href = '/CreateFranchise';
          } else if ([400, 409, 404, 500].includes(res.status)) {
            setShowPopup(false);
            setShowPopup1(true);
            // window.location.href = '/CreateFranchise';
          } else {
            setShowPopup(false);
            setShowPopup1(true);
            // window.location.href = '/CreateFranchise';
          }
        } catch (error) {
          console.error("Error creating franchise:", error);
        }

          }
          
const handlepanChange = async (event) => {
  const { name, value } = event.target;
  let processedValue = value.trim().toUpperCase();
setpan(false);
  // Allow only alphanumeric
  processedValue = processedValue.replace(/[^A-Z0-9]/g, "");

  // Restrict length to 10 (PAN length)
  processedValue = processedValue.slice(0, 10);

  // Call API only when PAN is complete (10 chars)
  // if (processedValue.length === 10) {
  //   await fetchPan(processedValue);
  // }

  // Update inputs state
  setInputs({
    ...inputs,
    [name]: processedValue,
  });

  // Validation: PAN should be 10 chars, format: 5 letters + 4 digits + 1 letter
 const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

setErrors((prev) => ({
  ...prev,
  [name]:
    processedValue.length < 1
      ? panRegex.test(processedValue)
        ? "" // Valid PAN, remove error
        : "Invalid PAN format" // Invalid PAN
      : "" // Less than 10 chars, don't show error yet
}));

};




const handleaadharChange = async (event) => {
  const { name, value } = event.target;

  // Allow only digits
  let processedValue = value.replace(/\D/g, "");

  // Restrict length to 12 (Aadhaar length)
  processedValue = processedValue.slice(0, 12);
    if (processedValue.length === 12) {
    // await fetchaadhar(processedValue);
  }

  // Update the input state
  setInputs({
    ...inputs,
    [name]: processedValue,
  });

  // Validation: Aadhaar must be exactly 12 digits
  const aadhaarRegex = /^\d{12}$/;
  setErrors({
    ...errors,
    [name]: processedValue
      ? aadhaarRegex.test(processedValue) ? "" : "Invalid Aadhaar number"
      : `${name} is required`,
  });
};


          const handleChange = (event) => {
            const { name, value, type } = event.target;
        
            let processedValue = value;
         processedValue =  processedValue.trim();
            if (type === "tel") {
           
              processedValue = value.replace(/\D/g, "");
              processedValue = processedValue.slice(0, 19);
            }
            if (name === "pincode") {
              processedValue = value.replace(/\D/g, "");
              processedValue = processedValue.slice(0, 6);
            }
            const pattern = /^[A-Za-z0-9]*$/;
        
            if (name === "panId") {
              // Replace non-alphanumeric characters with an empty string
              processedValue = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
        
              // Limit the processed value to a maximum length of 6 characters
              processedValue = processedValue.slice(0, 10);
          }
          if (name === "firstName" ) {
            // Replace non-alphanumeric characters with an empty string
            processedValue = value.replace(/[^a-zA-Z]/g, "");
        
            // Limit the processed value to a maximum length of 6 characters
            // processedValue = processedValue.slice(0, 10);
        }
        if (name === "lastName" ) {
          // Replace non-alphanumeric characters with an empty string
          processedValue = value.replace(/[^a-zA-Z]/g, "");
        
          // Limit the processed value to a maximum length of 6 characters
          // processedValue = processedValue.slice(0, 10);
        }
        if (name === "address"){
        
        
          processedValue = processedValue.slice(0, 100);
        }
           else if (pattern.test(value) || value === '') {
              setInputs({ ...inputs, [name]: value });
            }
            setInputs({
              ...inputs,
              [name]: typeof processedValue === 'string' ? processedValue.trimStart() : processedValue,
            });
            
            
      
          setInputs((inputs) => ({
            ...inputs,
          
             ssaId: 243
          }));
         
            // setInputs((prevInputs) => ({ ...prevInputs, [name]: processedValue }));
            setErrors({
              ...errors,
              [name]: (value && typeof value === 'string' && value.trimStart()) ? "" : `${name} is required`,
            });
            
          };
          
          console.log(dealerValue);
          
          
             
  
  console.log(dealerValue);
  
//   const handleSubmit = async (e) => {
//   e.preventDefault();
// console.log("submit");
//   // reset OTP state
//   setOtppop(false);
//   setTimerActive(true);
//   setmessage(false);
//   setSeconds(60); 
//   setOtp("");
//   setOtpMessage(false);

//   console.log("Inputs:", inputs);

//    e.preventDefault();

//     const isEmpty = Object.values(inputs).some((value) => 
//       typeof value === 'string' && value.trimStart() === ""
//     );    
//     if (isEmpty) {
//       const newErrors = {};
//       for (const key in inputs) {
//         const value = inputs[key];
//         if (typeof value === 'string' && value.trimStart() === "") {
//           newErrors[key] = `${key.charAt(0).toUpperCase() + key.slice(1)} is required`;
//         }
//       }
//       setErrors(newErrors);
//       const isValid = Object.values(inputs).some((value) => typeof value === 'string' && value.trimStart() !== "");
//       setFormValid(isValid);
//     }
// if (RoleId == 3){
//   if (dealerValue == 1) {
//       // Reset errors
//       console.log("submit123455");
//       setInputs({ ...inputs, franchiseMsisdn:"", subFranchiseMsisdn:""});
//       if (inputs.houseNumber !== '' && inputs.firstName !== '' &&
//         inputs.lastName !== '' && inputs.address !== '' && inputs.ctopupMsisdn !== '' &&
//         inputs.category !== '' && inputs.circleId !== '' && ssain !== ''
//         && inputs.dealerType !== ''  &&inputs.emailId !== ""
//         && inputs.mobile !== '' && inputs.houseNumber !== ''
//         && inputs.pincode !== ''  && inputs.dob !== '' && inputs.franchiseMsisdn === '' && 
//         inputs.subFranchiseMsisdn === ''  && inputs.panId !== "" && inputs.aadhaarId !== "" 

//         ) {

//           fetchotp();
//           };
        
//           // 2nd step Validate OTP //
            
//       }
    
//     else if (dealerValue == 2 ) {
//       setInputs({ ...inputs, subFranchiseMsisdn: "" });
//       if (inputs.houseNumber !== '' && inputs.firstName !== '' &&
//         inputs.lastName !== '' && inputs.address !== '' && inputs.ctopupMsisdn !== '' &&
//         inputs.category !== '' && inputs.circleId !== '' && ssain !== ''
//         && inputs.dealerType !== ''  && inputs.mobile !== '' && inputs.houseNumber !== ''
//         && inputs.pincode !== ''  && inputs.dob !== ''
//       && inputs.franchiseMsisdn !== '' && error === "Franchise" && inputs.subFranchiseMsisdn === ''  && inputs.panId !== "" && inputs.aadhaarId !== "" ) {

     
//         fetchotp();

//       }
//     }
//     else if (dealerValue == 3) {
//       if (inputs.houseNumber !== '' && inputs.firstName !== '' &&
//         inputs.lastName !== '' && inputs.address !== '' && inputs.ctopupMsisdn !== '' &&
//         inputs.category !== '' && inputs.circleId !== '' && ssain !== ''
//         && inputs.dealerType !== ''  && inputs.mobile !== '' && inputs.houseNumber !== ''
//         && inputs.pincode !== ''  && inputs.dob !== ''
//       && inputs.franchiseMsisdn !== '' && error === "Franchise" && inputs.panId !== "" && inputs.aadhaarId !== ""  ) {
// if (inputs.subFranchiseMsisdn.length == 10){
//   if (error1 === "Sub Franchise"){ 
//     fetchotp();
//         }
        
//       }
//       else{
//    fetchotp();
//       }
//       }
//     }
// }
// else{
//     if (dealerValue == 1) {
//       // Reset errors
//       console.log("submit123455");
//       setInputs({ ...inputs, franchiseMsisdn:"", subFranchiseMsisdn:""});
//       if (inputs.houseNumber !== '' && inputs.firstName !== '' &&
//         inputs.lastName !== '' && inputs.address !== '' && inputs.ctopupMsisdn !== '' &&
//         inputs.category !== '' && inputs.circleId !== '' && inputs.ssaId !== ''
//         && inputs.dealerType !== '' &&inputs.emailId !== ""
//         && inputs.mobile !== '' && inputs.houseNumber !== ''
//         && inputs.pincode !== ''  && inputs.dob !== '' && inputs.franchiseMsisdn === '' && 
//         inputs.subFranchiseMsisdn === ''  && inputs.panId !== "" && inputs.aadhaarId !== "" 

//         ) {

//           fetchotp();
//           };
        
//           // 2nd step Validate OTP //
            
//       }
    
//     else if (dealerValue == 2 ) {
//       setInputs({ ...inputs, subFranchiseMsisdn: "" });
//       if (inputs.houseNumber !== '' && inputs.firstName !== '' &&
//         inputs.lastName !== '' && inputs.address !== '' && inputs.ctopupMsisdn !== '' &&
//         inputs.category !== '' && inputs.circleId !== '' && inputs.ssaId !== ''
//         && inputs.dealerType !== ''  
//         && inputs.mobile !== '' && inputs.houseNumber !== ''
//         && inputs.pincode !== ''  && inputs.dob !== ''
//       && inputs.franchiseMsisdn !== '' && error === "Franchise" && inputs.subFranchiseMsisdn === ''  && inputs.panId !== "" && inputs.aadhaarId !== "" ) {

     
//         fetchotp();

//       }
//     }
//     else if (dealerValue == 3) {
//       if (inputs.houseNumber !== '' && inputs.firstName !== '' &&
//         inputs.lastName !== '' && inputs.address !== '' && inputs.ctopupMsisdn !== '' &&
//         inputs.category !== '' && inputs.circleId !== '' && inputs.ssaId !== ''
//         && inputs.dealerType !== '' 
//         && inputs.mobile !== '' && inputs.houseNumber !== ''
//         && inputs.pincode !== ''  && inputs.dob !== ''
//       && inputs.franchiseMsisdn !== '' && error === "Franchise" && inputs.panId !== "" && inputs.aadhaarId !== ""  ) {
// if (inputs.subFranchiseMsisdn.length == 10){
//   if (error1 === "Sub Franchise"){ 
//     fetchotp();
//         }
        
//       }
//       else{
//    fetchotp();
//       }
//       }
//     }
// }
    
//   }

  // const dealercreated1 = dealercreated;
  const handleClosePopup1 = () => {

    window.location.href = "/";
   
  };



 
const handleDropdownChange = async (event) => {
   const { name, value } = event.target;
  setSelectedDealerType(value);        
  setDealervalue(value);
  
  setInputs((prevInputs) => ({ ...prevInputs, [name]: value }));
           
  console.log(value);  
    if (value === "2") {
      setM2("");
      setShouldAddInput(true);
      setShouldAddInputs(false); 
    } else if (value === "3") {
      setShouldAddInput(true); 
      setShouldAddInputs(true);
    }
    else if (value === "1") {
      setIsSubmitting(false);
setM1("");
setM2("");
      setShouldAddInputs(false);
      setShouldAddInput(false);
    } else {
      // Handle other cases if needed
      setShouldAddInput(false);
      setShouldAddInputs(false);
    }

    setErrors({
      ...errors,
      [name]: (value && typeof value === 'string' && value.trimStart()) ? "" : `${name} is required`,
    });
    
  };

  // const handleChangee1 = async () => {
  //   const OPTIONS = {
  //     method: 'GET',
  //     headers: { 'Content-Type': 'application/json' },
  //   };
  //   try {
  //     const response = await fetch(`${DealerUrl}/ctopup-dealer-api/franchise?msisdn=${m1}`, OPTIONS);
  //     const data = await response.json();

  //     if (data.status === 200) {
  //       setIsSubmitting(false);
  //       setShow(true);
  //       setError(data.message);
  //       ;
  //     } else {
  //       setShow(true);
  //       setIsSubmitting(true);
  //       setError(data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching circles:", error);
  //     setError("An error occurred while fetching data.");
  //   }
  // };

  // const handleChangee2 = async () => {

  //   const OPTIONS = {
  //     method: 'GET',
  //     headers: { 'Content-Type': 'application/json' }
  //   };
  //   try {
  //     const response = await fetch(`${DealerUrl}/ctopup-dealer-api/subFranchise?msisdn=${m2}`, OPTIONS);
  //     const data1 = await response.json();
  //     console.log(data1);
  //     if (data1.status === 200) {
  //       setIsSubmitting(false);
  //       setShow1(true);
  //       setError1(data1.message);
  //     } else {
  //       setError1(data1.message);
  //       setIsSubmitting(true);
  //       setShow1(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching circles:", error);
  //   }
  // }

  const handleChange1 = (event) => {
    const { name, value, type } = event.target;
    let processedValue = value;

    // Apply maxlength validation for "tel" type input
    if (type === "tel") {
       processedValue = value.replace(/\D/g, ""); // Remove non-digit characters
      processedValue = processedValue.slice(0, 15); // Limit to 15 characters
    }
    setInputs({
      ...inputs,
      [name]: processedValue.trim(),
    });
    setM1(processedValue); // Update state with processed value
    setErrors({ ...errors, [name]: processedValue.trim() ? "" : `${name} is required` });
  };

  const handleChange2 = (event) => {
    const { name, value, type } = event.target;
    let processedValue = value;
    if (type === "tel") {
      processedValue = value.replace(/\D/g, "");
      processedValue = processedValue.slice(0, 15);
    }
    setInputs({
      ...inputs,
      [name]: processedValue.trim(),
    });

    setM2(processedValue);
    setErrors({ ...errors, [name]: value.trim() ? "" : `${name} is required` });
  };


  useEffect(() => {
    if (m1.length === 10) {
      // handleChangee1();
    } else {
      setShow(false);
    }
  }, [m1]);

  useEffect(() => {
    if (m2.length === 10) {
      // handleChangee2();
    } else {
      setShow1(false);

    }
  }, [m2]);

  const handlerefresh = () => {
     window.location.href="/CreateFranchise";
  }

  return (
    <div className="container mt-3">
       <div className="head text-white">
          <h3 className="gradient-title ms-2">Dealer Creation</h3>
        </div>
      <div className="card my-2 ms-2 mb-3" style={{border: "none", marginLeft: "-20px" , backgroundColor:'lightgray' }}>
       
        <form className="m-2" onSubmit={handleSubmit}>
          <section>
           
           
            <div className="row m-2 mt-4">
             
              {/* {showMand ? <p style={{marginLeft:"-183px",color:"#fc692a",marginTop:"10px"}}>
                  Please enter valid OTP</p> :''} */}
            
              {/* {showMand ? <p style={{marginLeft:"-183px",color:"#fc692a",marginTop:"10px"}}>
                  Please enter valid OTP</p> :''} */}
              <label className="col-12 col-sm-6 col-md-4 form-label">
                Contact Number (M)<span style={{ color: '#fc692a' }}>*</span>
                <br />
                <input
                  className="  form-control"
                  type="tel"
                  name="mobile"
                  value={inputs.mobile}
                  onChange={handleChange}
                  disabled={showPopup || showPopup1}
                  placeholder=" Enter Number (Mobile)"
                 pattern="^[0-9]+$|^[^\s]+$"
                  maxLength={10}
                  minLength={10}
                />
                {errors.mobile ? <p style={{ color: "#fc692a" }}>
                  {"Mobile Number is required" }</p> : ''}
              </label>
              {/* {showMand ? <p style={{marginLeft:"-183px",color:"#fc692a",marginTop:"10px"}}>
                  Please enter valid OTP</p> :''} */}
                      <label className="col-12 col-sm-6 col-md-4 form-label">
                First Name<span style={{ color: '#fc692a' }}>*</span>
                <br />
                <input
                  className="form-control "
                  type="text "
                  name="firstName"
                  value={inputs.firstName}
                  onChange={handleChange}
                  disabled={showPopup || showPopup1}
                  placeholder=" Enter First Name"
                  pattern="[A-Za-z]+"
                  title="Only alphabetic characters are allowed"
                />
                {errors.firstName ? <p style={{ color: "#fc692a" }}>
                  {"First Name is required" }</p> : ''}
              </label>
                <label className="col-12 col-sm-6 col-md-4 form-label">
                Last Name<span style={{ color: '#fc692a' }}>*</span>
                <br />
                <input
                  className=" form-control  "
                  name="lastName"
                  value={inputs.lastName}
                  onChange={handleChange}
                  disabled={showPopup || showPopup1}
                  type="text"
                  placeholder=" Enter Last Name"
                  pattern="[A-Za-z]+"
                  title="Only alphabetic characters are allowed"
                />
                {errors.lastName ? <p style={{ color: "#fc692a" }}>
                  {"Last Name is required"} </p> : ''}
              </label>
            </div>
          </section>

          <section>
            <div className="row m-2 ">
        
            
              {/* {showMand ? <p style={{marginLeft:"-183px",color:"#fc692a",marginTop:"10px"}}>
                  Please enter valid OTP</p> :''} */}
  <label className="col-12 col-sm-6 col-md-4 form-label">
                Dob (dd-mm-yy)<span style={{ color: '#fc692a' }}>*</span>
                <br />
                <input
                  className=" form-control "
                  type="date"
                  name="dob"
                  value={inputs.dob}
                  disabled={showPopup || showPopup1}
                  onChange={handleChange}
                  placeholder=" Enter DOB (DD-MM-YY)"
                  max={formattedEighteenYearsAgo}
                />
                {errors.dob ? <p style={{ color: "#fc692a" }}>
                  {errors.dob} </p> : ''}
              </label>
           
  <label className="col-12 col-sm-6 col-md-4 form-label">
                Pincode<span style={{ color: '#fc692a' }}>*</span>
                <br />
                <input
                  className="form-control "
                  type="tel"
                  name="pincode"
                  value={inputs.pincode}
                  minLength={6 }
                  pattern="^[0-9]+$|^[^\s]+$"
                  disabled={showPopup || showPopup1}
                  onChange={handleChange}
                  placeholder=" Enter Pincode"
                />
                {errors.pincode ? <p style={{ color: "#fc692a" }}>
                  {errors.pincode} </p> : ''}
              </label>
              <label className="col-12 col-sm-6 col-md-4 form-label">
                Address<span style={{ color: '#fc692a' }}>*</span>
                <br />
              <textarea 
  className="form-control"
  name="address"
  value={inputs.address || ""}
  disabled={showPopup || showPopup1}
  onChange={handleChange}
  placeholder="Enter Address"
  rows={3}
></textarea>
               
                {errors.address ? <p style={{ color: "#fc692a" }}>
                  {errors.address} </p> : ''}
              </label>
            </div>
            <div className="row m-2 ">
             
            
              {/* {showMand ? <p style={{marginLeft:"-183px",color:"#fc692a",marginTop:"10px"}}>
                  Please enter valid OTP</p> :''} */}

            
             
              {/* {showMand ? <p style={{marginLeft:"-183px",color:"#fc692a",marginTop:"10px"}}>
                  Please enter valid OTP</p> :''} */}
    
    

            </div>
            <div className="row m-2">

   
            
            
              {/* {showMand ? <p style={{marginLeft:"-183px",color:"#fc692a",marginTop:"10px"}}>
                  Please enter valid OTP</p> :''} */}

              {/* {showMand ? <p style={{marginLeft:"-183px",color:"#fc692a",marginTop:"10px"}}>
                  Please enter valid OTP</p> :''} */}

            </div>
          
         

            <div className="row  me-4">
              <div className=" col  me-5 d-flex justify-content-end">
                <button
                  style={{ backgroundColor:" #FE7235"}}
                  className=" buton btn text-white  me-4"
                  type="submit" 
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom" 
                  title="Click-me"
                  disabled={showPopup || showPopup1}>
                  Submit
                </button>
                <button
                  //  onClick={completeformSetup}
                  style={{ backgroundColor:" #FE7235"}}
                  className=" buton  btn text-white me-5"
                  type="submit"
                 onClick={handlerefresh}
                 disabled={showPopup || showPopup1}
                >
                 Cancel
                </button>
              </div>
            </div>
          </section>
        </form>

        <div>
           {showPopup1 && (
  <div className="custom-modal-overlay">
    <div className="custom-modal">
      <p className="modal-message">{dealercreated.message}</p>
      <button
        className="modal-btn"
        onClick={handleClosePopup1}
      >
        OK
      </button>
    </div>
  </div>
)}
            </div>
        <div className="col-5 mt-5">
     
    
        </div>
      </div>
    </div>
  );
};
export default Dealerform;